import { castInto } from '../../utils/helper';
function normalizePercentage(percentage) {
    if (percentage === void 0) { percentage = 0; }
    return castInto(percentage, [0, 100]);
}
function getAnimationDuration(oldPercentage, newPercentage, duration) {
    return Math.abs(newPercentage - oldPercentage) * duration;
}
export function createNewSegment(_a) {
    var _b = _a.oldPercentage, oldPercentage = _b === void 0 ? 0 : _b, newPercentage = _a.newPercentage, duration = _a.duration;
    var normalizedPercentage = normalizePercentage(newPercentage);
    return {
        normalizedPercentage: normalizedPercentage,
        animationDuration: getAnimationDuration(oldPercentage, normalizedPercentage, duration),
    };
}
